import axios from 'axios'
import authService from '../../auth/authService'

axios.interceptors.request.use(async function (config) {
    const token = await authService.getToken()
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    } else {
        console.log('no token')
    }

    return config
})

class HttpService {
    constructor () {
        this.apiPath = 'https://api.kinder-fussball-karlsruhe.de'
     // this.apiPath = 'http://localhost:5000'
    }
}

export default new HttpService()
